<!-- =========================================================================================
  File Name: user.vue
  Description: Report User
========================================================================================== -->

<template>
  <div id="report-user">

    <vx-card title="会员报表">
      <div slot="actions">
        <vx-input-group>
          <template slot="prepend">
            <flat-pickr v-model="startTime" :config="flatPickrConfig" class="flatpickr-input w-32"></flat-pickr>
          </template>
          <flat-pickr v-model="endTime" :config="flatPickrConfig" class="flatpickr-input w-32"></flat-pickr>
          <template slot="append">
            <div class="append-text bg-warning cursor-pointer" @click="search">
              <feather-icon icon="SearchIcon"></feather-icon>
            </div>
          </template>
        </vx-input-group>
      </div>
      <div class="vx-row">
        <div class="vx-col sm:w-1/3">
          <vx-card>
            <vs-table stripe :data="list" noDataText="暂无报表记录" class=" w-full">
              <template slot="thead">
                <vs-th width="180">日期</vs-th>
                <vs-th>注册数量</vs-th>
              </template>
              <template slot-scope="{data}">
                <vs-tr :key="index" v-for="(item, index) in list">
                  <vs-td :data="index">{{index}}</vs-td>
                  <vs-td :data="item.count" :class="{ 'font-bold': item.count > 0 }">{{item.count}}</vs-td>
                </vs-tr>
                <vs-tr>
                  <vs-td class="font-bold">合计</vs-td>
                  <vs-td :class="{ 'font-bold': total > 0 }">{{total}}</vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </vx-card>
        </div>
        <div class="vx-col sm:w-2/3">
          <vx-card>
            <vue-apex-charts v-if="chartData.loaded" height=400 :options="chartData.chartOptions" :series="chartData.series" />
          </vx-card>
        </div>
      </div>


    </vx-card>

  </div>
</template>

<script>

import VueApexCharts from 'vue-apexcharts'
import { Mandarin as flatPickrZh } from 'flatpickr/dist/l10n/zh.js'

export default {
  data() {
    return {
      list: [],
      startTime: '',
      endTime: '',
      total: 0,
      flatPickrConfig: {
        enableTime: false,
        dateFormat: 'Y-m-d',
        locale: flatPickrZh
      },
      chartData: {
        loaded: false,
        series: [{
          name: '注册人数',
          data: []
        }],
        chartOptions: {
          chart: {
            type: 'line',
            toolbar: {
              show: false
            }
          },
          title: {
            text: '注册人数折线图',
            align: 'left'
          },
          xaxis: {
            categories: []
          }
        }
      }
    }
  },
  components: {
    VueApexCharts
  },
  methods: {
    load () {
      const postdata = {}
      postdata.authKey = localStorage.getItem('authKey')
      postdata.start = this.startTime
      postdata.end = this.endTime
      this.chartData.loaded = false
      this.$utils.post('report-user', postdata).then(res => {
        this.list = res
        this.chartData.series[0].data = []
        this.chartData.chartOptions.xaxis.categories = []
        this.total = 0
        for (const i in res) {
          this.chartData.series[0].data.unshift(res[i].count)
          this.chartData.chartOptions.xaxis.categories.unshift(i)
          this.total += parseFloat(res[i].count)
        }
        this.chartData.loaded = true
      })
    },
    search() {
      this.load()
    }
  },
  mounted () {
    // 初始化时间
    const myDate = new Date()
    this.endTime = this.$utils.addZero(myDate.getFullYear(), 2) + '-' + this.$utils.addZero((parseInt(myDate.getMonth()) + 1), 2) + '-' + this.$utils.addZero(myDate.getDate(), 2)
    myDate.setTime(myDate.getTime() - 86400000 * 30)
    this.startTime = this.$utils.addZero(myDate.getFullYear(), 2) + '-' + this.$utils.addZero((parseInt(myDate.getMonth()) + 1), 2) + '-' + this.$utils.addZero(myDate.getDate(), 2)

    this.load()
  }
}
</script>
